module.exports = __webpack_public_path__ + "5b58d2bd159a3b78bba80a692061100c.pdf";